import React, { useRef,useState,useEffect } from "react";
import { useHistory } from "react-router-dom";
import {motion} from "framer-motion";
import {useSelector,useDispatch} from 'react-redux'
import {setEducationDetails} from '../actions'
import Education from './Education'

const contVariant={
  hidden:{
    x:"100vw"
  },
  visible:{
    x:0,
    transition:{
      delay:0.1,
      type:"spring",
      stiffness:80,
      mass:0.4,
      damping:8
    }
  }
}
const linkVariant={
  hover:{
    textShadow: "2px 2px 10px rgba(0,0,0,0.8)",
    boxShadow:"2px 2px 10px rgba(0,0,0,0.8)",
    transition:{
      duration:0.2
    }
  }
}
export default function EducationDetails() {
  const resumeEducations=useSelector(states=>states.resumeData).education
  const [educations,setResumeEducations]=useState(()=>{
    return resumeEducations
  })
  const dispatch=useDispatch()
  const history = useHistory();
  const [course,field,college,score,start,end] = [
    useRef(""),
    useRef(""),
    useRef(""),
    useRef(""),
    useRef(""),
    useRef()
  ];
  function handleSubmit(e) {
    e.preventDefault();
    dispatch(setEducationDetails(educations))
    history.push("/add-skills");
  }
  function addEducation(e){
    e.preventDefault();
    setResumeEducations((prevEducations)=>{
      return [...prevEducations,{course:course.current.value,field:field.current.value,college:college.current.value,score:score.current.value,start:start.current.value,end:end.current.value}]
    })
  }
  function removeEducation(id){
    setResumeEducations((prevEducations)=>{
      return prevEducations.filter((education,index)=>index!==id)
    })
  }
  useEffect(()=>{
    course.current.value=''
    field.current.value=''
    college.current.value=''
    score.current.value=''
    start.current.value=''
    end.current.value=''
  },[educations])
  return (
    <motion.div className="container" exit={{x:"-100vw"}}>
      <motion.div className="form"
        variants={contVariant}
        initial="hidden"
        animate="visible"
      >
        <h1><i class="mr-2 fas fa-university"></i>Education Details</h1>
        <form onSubmit={addEducation}>
          <input type="text" ref={course} placeholder="Course/Standard" required />
          <input
            type="text"
            ref={field}
            placeholder="Field/Board"
            required
          />
          <input type="text" ref={college} placeholder="College/School" required />
          <input type="number" max="100" min="0" ref={score} placeholder="Aggregate in percentage, & do not specify '%' sign" required/>
          <div>
            <div className="my-2">Duration</div>
              <div className="d-flex justify-content-center">
                <input type="month" ref={start} required />
                <input type="month" ref={end}  required />
              </div>
          </div>
          <motion.button variants={linkVariant} whileHover="hover" type="submit">add</motion.button>
        </form>
        <ul>
          {educations.map((education,index)=>{
            return (<Education education={education} key={index} id={index} removeEducation={removeEducation} />)
          })}
        </ul>
        {educations!=0 && <motion.button variants={linkVariant} whileHover="hover" className="save-btn" onClick={handleSubmit}>save & next</motion.button>}
      </motion.div>
    </motion.div>
  );
}
